// import { logger } from '@/helpers';
import { defineComponent ,reactive,onMounted,computed,ref } from 'vue'
// import { onBeforeRouteLeave } from "vue-router";
import { useRouter } from "vue-router";
// import platform from "platform";

import LogoSmall from "@/components/LogoSmall/LogoSmall.vue";
import { useStore } from "vuex";


import { Form } from '@/types/Form'
import {  ApiService } from '@/api/api';

import {  useReCaptcha } from 'vue-recaptcha-v3'
import { useGtag } from "vue-gtag-next";

import PopupCookie from "@/components/PopupCookie/PopupCookie.vue";


export default defineComponent({
  // type inference enabled

  components:{
    LogoSmall,
    PopupCookie
  },
  setup() {
    const { pageview,event } = useGtag();
    const store = useStore();
    const router = useRouter();
    const IsFull =ref(false);

    const reCaptcha = useReCaptcha();

    const FormState = reactive<Form>({
      firstname:'',
      lastname:'',
      message:'',
      mobile:''
     
    })

    const ShowCookies = computed(() => store.getters['GetPopupCookies'])

    const registerid =  store.getters['Card/getRegisterID']

    // const IsIos =  () =>{
    //   if (platform.os?.family == 'iOS' || platform.os?.family == 'iPadOS'){
    //     return true;
    //   }else if(platform.os?.family =='OS X'){//
    //     return true;
    //   }else{
    //     return false
    //   }
     
    // } 


    const rules = {
      firstname: [{ required: true,message: ''}],
      lastname: [{ required: true,message: ''}],
      mobile: [{ required: true,message: ''},{pattern:/[0-9]{10}/ ,message:"เบอร์โทรศัพท์ไม่ถูกต้อง"    }],
      message: [{ required: true,message: ''}],
      
    };

    // eslint-disable-next-line 
    const onFinish = (values: Form) => {
      // console.log('Success:', values);
      // eslint-disable-next-line
      // (window as any).fbq('track', 'CompleteRegistration') 
      SendData(values);
     
    };

    const SendData = async (values:Form) =>{
      event('apirequest', { 'event_category' : 'submitform',    })
      await reCaptcha?.recaptchaLoaded();

      const token = await reCaptcha?.executeRecaptcha('submit');
      const RequestParam = {...values, "registerid":registerid ,"siteresponse" : token }

      const RequestResp = await ApiService.UserRegister(RequestParam)
      const {data}  = RequestResp 

      if(data.result =='complete'){
        router.push('/LuckydrawResult')
        // alert('Complete')
      }else if(data.result == 'error'){
        if(data.detail == 'quota_full'){
          event('apirespone', { 'event_category' : 'quota_full',    })
          IsFull.value= true

        }else if(data.detail == 'invalid_registerid'){
          // router.push('/LuckydrawResult')
          router.push('/')
        }
      }
       window.removeEventListener("beforeunload", beforeUnloadListener,{capture:true});
    }

    // eslint-disable-next-line 
    const onFinishFailed = (errorInfo: any) => {
      console.log('Failed:', errorInfo);
    };

    // eslint-disable-next-line
    const beforeUnloadListener = (event:any) => {
      event.preventDefault();
      return event.returnValue = "Are you sure you want to exit?";
    };


    const btActive = computed(() => {
      if(FormState.firstname != ''  && FormState.lastname != '' && FormState.message != '' && FormState.mobile.length == 10){
        return true
      }
      return false;
    });

    // eslint-disable-next-line
    const isNumber = (evt : any) => {
      const charCode = evt?.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 9) {
        evt.preventDefault();
      } else {
        
        return true;
      }
    }

  

    onMounted(() => {
      // eslint-disable-next-line
      (window as any).fbq('track', 'AddInfo') 
      pageview({ page_path: "/Form" });
      if(registerid == ''){
        router.push('/')
      }else{
        window.addEventListener("beforeunload", beforeUnloadListener,{capture:true});
      }
    })


    const ShowPopupCookie = () => {
   
      store.dispatch("SetPopupCookie", true);

      setTimeout(() => {  
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }, 100);

    
    };

    


    return { btActive, IsFull, FormState, rules, onFinish, onFinishFailed, registerid, isNumber, ShowCookies, ShowPopupCookie}
  

  },
})
